import api from '../../../config';

const path = 'v1/messmittel/typ';

export default {
  get: () => api.get(path),
  getById: (id) => api.get(`${path}/${id}`),
  create: (name) => api.post(path, { name }),
};
